/* eslint-disable import/prefer-default-export */
import { useQuery } from "@tanstack/react-query";
import { getFileImportHistory } from "api/services/fileImport";
import { fileImportQueryKeys } from "./fileImportQueryKeys";

export function useGetFileImportList(filters: any) {
  return useQuery({
    queryKey: fileImportQueryKeys.fileImportList(filters),
    queryFn: () => getFileImportHistory({ params: filters }).then((res) => res.data),
  });
}
